import { render, staticRenderFns } from "./SecondaryNavbar.vue?vue&type=template&id=67000080&scoped=true"
import script from "./SecondaryNavbar.vue?vue&type=script&lang=js"
export * from "./SecondaryNavbar.vue?vue&type=script&lang=js"
import style0 from "./SecondaryNavbar.vue?vue&type=style&index=0&id=67000080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67000080",
  null
  
)

export default component.exports